<template>
    <!--頁尾-->
    <footer class="footer">
        <div class="conbox footerin">
            <div class="fotlogo">
                <!--回首頁-->
                <a href="/EN/">
                    <img src="/images/footerLogo.svg" alt="臺灣大學生物產業傳播暨發展學系"/>
                </a>
            </div>
            <div class="fotinf">
                <a href="/EN/Copyright">Privacy & Security Policy</a>
                <br>
                <!--相關資訊-->
                Address：1, Sec. 4, Roosevelt Rd. Taipei, 106 Taiwan (College of Agriculture Bldg 4th Floor)
                <br>
                Tel：(02)33664411 (8:30-12:30 / 13:30-17:30) ｜ fax：(02)23635879 ｜ E-Mail：ntubicd@ntu.edu.tw
                <!-- TODO 動態新增相關資訊文字&計算瀏覽人數-->
                <br>
                Visits： <span>{{ vnumber /*輸入瀏覽人數*/ }}</span> | Last update at：<span>{{ this.updateDate /*輸入最後更新日期*/ }}</span>
            </div>
        </div>
    </footer>
</template>
<script>
import $ from 'jquery';
import VueQrcode from '@chenfengyuan/vue-qrcode';
//取得現在日期
var date = new Date();
//設定日期文字模式
var dateFormat = date.getFullYear() + "/" + (date.getMonth()+1) + "/" + date.getDate() + " "+ date.getHours() + ":" + date.getMinutes();
export default{
    components:{
        VueQrcode,
    },
    data(){
        return{
            totalCount: 1,
            pageCount: 1,
            
            pageUrl: null,
            pagination: {
                perPage: 99,
                page: 1,
                rows: null,
            },
            //TODO 取得各類別列表
            footerDetail: null,
            qrcodeDetail: null,
            footerCountDetail: null,
            //造訪人數
            vnumber:0,
            //最後更新日期
            updateDate: dateFormat,
        };
    },
    props:["footer"],
    mounted() {
        //初始化
        this.init();
    },
    watch:{},
    methods:{
        //初始化
        async init(){
            //計數點擊人數
            await this.updateHit();
            //取得頁尾資訊
            this.getFooter();
            //取得最後修改日期
            this.getLastUpdateDate();
        },
        //計數點擊人數
        async updateHit(){
            try {
                //query參數
                let jsonReq ={
                    TYPE:"UPDATE",
                    calculate_UPDATE: {
                        Page: this.$route.path,
                        DateTime: new Date(),
                        langurage:2,
                    },
                }
                //Token 
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //API執行
                let res = await this.userRequest.post("bicd/Calculate",jsonReq);
            }catch(err){
                console.log("ErrFunction: updateHit/n "+err);
            }
        },
        //取得頁尾資訊
        async getFooter(){
            try{
                //query參數
                let jsonReq ={
                    TYPE:"SELECT_Front",
                    calculate_SELECT: {
                        Page: this.$route.path,
                        DateTime: new Date(),
                        langurage:2,
                    },
                }
                //Token 
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //API執行
                let res = await this.userRequest.post("bicd/Calculate",jsonReq);
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    this.vnumber = jsonData.Total_Count;
                }
            }catch(err){
                console.log("ErrFunction: getFooter/n "+err);
            }
        },
        //取得最後修改日期
        async getLastUpdateDate() {
            try{
                //query參數
                let jsonReq = {
                    TYPE: "HOME_SELECT",
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token"); 
                jsonReq.Token = resToken.data;
                //API參數
                let res = await this.userRequest.post("bicd/BrowseLog",jsonReq);
                let json = JSON.parse(res.data);
                if (json.Status) {
                    this.updateDate = json.Data;
                }
            }catch(err){
                console.log("ErrFunction: getLastUpdateDate/n "+err);
            }
        },
    }
}
</script>